import {CardBannerDto} from '../../common/shared/api/gateway/CardBannerDto.type';
import {
  CardSection,
  GroupType,
  Maybe,
  SectionType,
  User,
} from '../generated/types';
import {createCardViewItem} from './CardViewItem';

export function createCardSectionWithBannerDto(
  userInfo: Maybe<User>,
  {
    layoutId,
    bannerList,
  }: {
    layoutId: string;
    bannerList: CardBannerDto[];
  }
): CardSection {
  const sectionId = `${layoutId}-section-card-banner`;
  return {
    id: sectionId,
    type: SectionType.CardBanner,
    groups: [
      {
        id: `${sectionId}-group-card-view`,
        type: GroupType.CardView,
        items: bannerList.map(banner =>
          createCardViewItem(userInfo, {
            bannerItemDto: banner,
          })
        ),
      },
    ],
  };
}
